// src/theme/tokens.js
// Tokens de diseño para usar en estilos inline. Cada valor es una variable
// CSS de src/styles/tokens.css, así el modo claro/oscuro funciona solo.
//
//   import { C, FS, R, SP } from '../../theme/tokens';
//   <div style={{ background: C.card, color: C.text, borderRadius: R.md }}>
//
// Reemplaza al `const C = { bg:'var(--c-bg)', … }` que cada página copiaba.

export const C = {
  bg:        'var(--c-bg)',
  card:      'var(--c-card)',
  surface:   'var(--c-surface)',
  inputBg:   'var(--c-inputBg)',
  hover:     'var(--c-hover)',
  border:    'var(--c-border)',
  finde:     'var(--c-finde)',
  filaAlt:   'var(--c-fila-alt)',

  borderSoft: 'var(--c-border-soft)',

  text:      'var(--c-text)',
  secondary: 'var(--c-secondary)',
  subtext:   'var(--c-subtext)',
  muted:     'var(--c-muted)',
  dim:       'var(--c-dim)',

  accent:      'var(--c-accent)',
  accentHover: 'var(--c-accent-hover)',
  accentText:  'var(--c-accent-text)',
  accentSoft:  'var(--c-accent-soft)',
  accentLine:  'var(--c-accent-line)',
  onAccent:    'var(--c-on-accent)',

  success:     'var(--c-success)',
  successSoft: 'var(--c-success-soft)',
  warning:     'var(--c-warning)',
  warningSoft: 'var(--c-warning-soft)',
  danger:      'var(--c-danger)',
  dangerSoft:  'var(--c-danger-soft)',
  info:        'var(--c-info)',
  infoSoft:    'var(--c-info-soft)',
  infoStrong:  'var(--c-info-strong)',

  overlay:   'var(--c-overlay)',
};

// Un color con transparencia, para fondos suaves y bordes de chips.
// Sirve con variables: alpha(C.success, 12) → 12 % de opacidad.
export const alpha = (color, pct) => `color-mix(in srgb, ${color} ${pct}%, transparent)`;

// Acentos propios de cada sección de Gerencial (decisión: se conservan).
// color → relleno, borde, ícono, serie de gráfico (igual en los dos temas)
// text  → cuando el acento es letra (más oscuro en modo claro)
// soft / line → fondo y borde del ítem activo o de un chip
const ger = (k) => ({
  color: `var(--ger-${k})`,
  text:  `var(--ger-${k}-text)`,
  soft:  alpha(`var(--ger-${k})`, 10),
  line:  alpha(`var(--ger-${k})`, 35),
});
export const GERENCIAL = {
  marca:           ger('marca'),
  obras:           ger('obras'),
  prestaciones:    ger('prestaciones'),
  manoDeObra:      ger('mano-obra'),
  materiales:      ger('materiales'),
  certificaciones: ger('certificaciones'),
  curvas:          ger('curvas'),
  planReal:        ger('plan-real'),
  combustible:     ger('combustible'),
  equipos:         ger('equipos'),
  config:          ger('config'),
  finanzas:        ger('finanzas'),
};

// Tamaños de letra. No usar nada menor a FS.xs (12px).
export const FS = {
  xs:  'var(--fs-xs)',
  sm:  'var(--fs-sm)',
  md:  'var(--fs-md)',
  lg:  'var(--fs-lg)',
  xl:  'var(--fs-xl)',
  xxl: 'var(--fs-2xl)',
};

export const FW = { regular: 400, medium: 500, semi: 600, bold: 700 };

// Espaciado en múltiplos de 4px (números, para poder sumarlos).
export const SP = { 1: 4, 2: 8, 3: 12, 4: 16, 5: 20, 6: 24, 8: 32 };

export const R = { sm: 6, md: 10, lg: 14, pill: 999 };

export const SHADOW = { sm: 'var(--shadow-sm)', md: 'var(--shadow-md)' };
export const FOCUS_RING = 'var(--focus-ring)';

export const FONT = { sans: 'var(--font-sans)', mono: 'var(--font-mono)' };

export const TOUCH_MIN = 44;
